/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class AndonCallRecordConfirmExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 安灯呼叫确认记录导出
     * @param andonCallRecordConfirmSearchDTO andonCallRecordConfirmSearchDTO
     * @return OK
     */
    export(andonCallRecordConfirmSearchDTO: AndonCallRecordConfirmSearchDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-call-record-confirm-excel/excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonCallRecordConfirmSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AndonCallRecordConfirmServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 分页查询安灯呼叫确认信息
     * @param andonCallRecordConfirmSearchDTO andonCallRecordConfirmSearchDTO
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(andonCallRecordConfirmSearchDTO: AndonCallRecordConfirmSearchDTO, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfAndonCallRecordBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-call-record-confirm/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonCallRecordConfirmSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfAndonCallRecordBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfAndonCallRecordBO.fromJS(resultData200) : new IPageOfAndonCallRecordBO();
            return result200;
        }
        return Promise.resolve<IPageOfAndonCallRecordBO>(<any>null);
    }
}

export class AndonCallRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * Hmi上更新安灯呼叫信息状态
     * @param andonCallRecordUpdateStatusDTO andonCallRecordUpdateStatusDTO
     * @return OK
     */
    updateAndonCallRecordStatusHMI(andonCallRecordUpdateStatusDTO: AndonCallRecordUpdateStatusDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-call-record/HmiUpdateCallStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonCallRecordUpdateStatusDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAndonCallRecordStatusHMI(_response);
        });
    }

    protected processUpdateAndonCallRecordStatusHMI(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 创建安灯呼叫信息
     * @param andonCallRecordAddDTO andonCallRecordAddDTO
     * @return OK
     */
    createAndonCallRecord(andonCallRecordAddDTO: AndonCallRecordAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-call-record/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonCallRecordAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateAndonCallRecord(_response);
        });
    }

    protected processCreateAndonCallRecord(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 删除安灯呼叫
     * @param andonCallRecordIds andonCallRecordIds
     * @return OK
     */
    deleteAndonType(andonCallRecordIds: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-call-record/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonCallRecordIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteAndonType(_response);
        });
    }

    protected processDeleteAndonType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分页查询安灯呼叫信息
     * @param andonCallRecordSearchDTO andonCallRecordSearchDTO
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(andonCallRecordSearchDTO: AndonCallRecordSearchDTO, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfPageAndonCallRecordBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-call-record/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonCallRecordSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfPageAndonCallRecordBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfPageAndonCallRecordBO.fromJS(resultData200) : new IPageOfPageAndonCallRecordBO();
            return result200;
        }
        return Promise.resolve<IPageOfPageAndonCallRecordBO>(<any>null);
    }

    /**
     * 小程序查询安灯呼叫信息
     * @param andonCallRecordSearchDTO andonCallRecordSearchDTO
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageMini(andonCallRecordSearchDTO: AndonCallRecordSearchDTO, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfPageAndonCallRecordBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-call-record/pageMini?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonCallRecordSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageMini(_response);
        });
    }

    protected processPageMini(response: AxiosResponse): Promise<IPageOfPageAndonCallRecordBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfPageAndonCallRecordBO.fromJS(resultData200) : new IPageOfPageAndonCallRecordBO();
            return result200;
        }
        return Promise.resolve<IPageOfPageAndonCallRecordBO>(<any>null);
    }

    /**
     * 修改安灯呼叫信息备注
     * @param andonCallRecordUpdateDTO andonCallRecordUpdateDTO
     * @return OK
     */
    updateAndonCallRecord(andonCallRecordUpdateDTO: AndonCallRecordUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-call-record/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonCallRecordUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAndonCallRecord(_response);
        });
    }

    protected processUpdateAndonCallRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新安灯呼叫信息状态
     * @param andonCallRecordUpdateCallStatusDTOS andonCallRecordUpdateCallStatusDTOS
     * @return OK
     */
    updateAndonCallRecordStatus(andonCallRecordUpdateCallStatusDTOS: AndonCallRecordUpdateCallStatusDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-call-record/updateCallStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonCallRecordUpdateCallStatusDTOS);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAndonCallRecordStatus(_response);
        });
    }

    protected processUpdateAndonCallRecordStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class AndonReasonServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取单个安灯原因
     * @param id id
     * @return OK
     */
    getAndonReason(id: string): Promise<AndonReasonVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-reason?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAndonReason(_response);
        });
    }

    protected processGetAndonReason(response: AxiosResponse): Promise<AndonReasonVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AndonReasonVO.fromJS(resultData200) : new AndonReasonVO();
            return result200;
        }
        return Promise.resolve<AndonReasonVO>(<any>null);
    }

    /**
     * 新建安灯原因
     * @param dto dto
     * @return OK
     */
    saveAndonReason(dto: AndonReasonDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-reason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveAndonReason(_response);
        });
    }

    protected processSaveAndonReason(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 更新安灯原因
     * @param dto dto
     * @return OK
     */
    updateAndonReason(dto: AndonReasonDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-reason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAndonReason(_response);
        });
    }

    protected processUpdateAndonReason(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除安灯原因
     * @param ids ids
     * @return OK
     */
    deleteAndonReason(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-reason?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteAndonReason(_response);
        });
    }

    protected processDeleteAndonReason(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询所有安灯原因的code-name
     * @return OK
     */
    getCodeAndName(): Promise<AndonReasonCodeNameVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-reason/code-Name";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCodeAndName(_response);
        });
    }

    protected processGetCodeAndName(response: AxiosResponse): Promise<AndonReasonCodeNameVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AndonReasonCodeNameVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AndonReasonCodeNameVO[]>(<any>null);
    }

    /**
     * 根据类型id查询原因list
     * @param typeId (optional) typeId
     * @return OK
     */
    getPageAndonReasonByTypeId(typeId: string | null | undefined): Promise<AndonReasonVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-reason/list/byTypeId?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageAndonReasonByTypeId(_response);
        });
    }

    protected processGetPageAndonReasonByTypeId(response: AxiosResponse): Promise<AndonReasonVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AndonReasonVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AndonReasonVO[]>(<any>null);
    }

    /**
     * 分页查询安灯原因
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param typeId (optional) typeId
     * @return OK
     */
    getPageAndonReason(current: number | null | undefined, size: number | null | undefined, typeId: string | null | undefined): Promise<IPageOfAndonReasonVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-reason/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageAndonReason(_response);
        });
    }

    protected processGetPageAndonReason(response: AxiosResponse): Promise<IPageOfAndonReasonVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfAndonReasonVO.fromJS(resultData200) : new IPageOfAndonReasonVO();
            return result200;
        }
        return Promise.resolve<IPageOfAndonReasonVO>(<any>null);
    }
}

export class AndonStatisticsExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出呼叫频次添统计
     * @param andonStatisticsFrequencyExportDTO andonStatisticsFrequencyExportDTO
     * @return OK
     */
    getFrequencyReport(andonStatisticsFrequencyExportDTO: AndonStatisticsFrequencyExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-statistics-excel/frequency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonStatisticsFrequencyExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFrequencyReport(_response);
        });
    }

    protected processGetFrequencyReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AndonStatisticsServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 呼叫频次统计
     * @param andonStatisticsFrequencyDTO andonStatisticsFrequencyDTO
     * @return OK
     */
    getFrequencyReport(andonStatisticsFrequencyDTO: AndonStatisticsFrequencyDTO): Promise<AndonFrequencyStatisticsReportVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-statistics/frequency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andonStatisticsFrequencyDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFrequencyReport(_response);
        });
    }

    protected processGetFrequencyReport(response: AxiosResponse): Promise<AndonFrequencyStatisticsReportVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AndonFrequencyStatisticsReportVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AndonFrequencyStatisticsReportVO[]>(<any>null);
    }
}

export class AndonTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取安灯类型
     * @param id id
     * @return OK
     */
    getAndonType(id: string): Promise<AndonTypeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAndonType(_response);
        });
    }

    protected processGetAndonType(response: AxiosResponse): Promise<AndonTypeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AndonTypeVO.fromJS(resultData200) : new AndonTypeVO();
            return result200;
        }
        return Promise.resolve<AndonTypeVO>(<any>null);
    }

    /**
     * 新建安灯类型
     * @param dto dto
     * @return OK
     */
    saveAndonType(dto: AndonTypeDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveAndonType(_response);
        });
    }

    protected processSaveAndonType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 更新安灯类型
     * @param dto dto
     * @return OK
     */
    updateAndonType(dto: AndonTypeDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAndonType(_response);
        });
    }

    protected processUpdateAndonType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除安灯类型
     * @param ids ids
     * @return OK
     */
    deleteAndonType(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteAndonType(_response);
        });
    }

    protected processDeleteAndonType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询所有安灯类型的code-name
     * @param keyWord (optional) keyWord
     * @return OK
     */
    getCodeAndName(keyWord: string | null | undefined): Promise<AndonTypeCodeNameVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type/code-Name?";
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCodeAndName(_response);
        });
    }

    protected processGetCodeAndName(response: AxiosResponse): Promise<AndonTypeCodeNameVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AndonTypeCodeNameVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AndonTypeCodeNameVO[]>(<any>null);
    }

    /**
     * 导出安灯类型
     * @param keyWord (optional) keyWord
     * @return OK
     */
    export(keyWord: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type/export?";
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出安灯呼叫模板
     * @return OK
     */
    exportTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type/export/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportTemplate(_response);
        });
    }

    protected processExportTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入安灯呼叫
     * @param file (optional) file
     * @return OK
     */
    importAndonReason(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportAndonReason(_response);
        });
    }

    protected processImportAndonReason(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询所有安灯类型
     * @return OK
     */
    getAllAndonType(): Promise<AndonTypeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type/list-all-andon-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllAndonType(_response);
        });
    }

    protected processGetAllAndonType(response: AxiosResponse): Promise<AndonTypeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AndonTypeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AndonTypeVO[]>(<any>null);
    }

    /**
     * 关键词和分页查询安灯类型
     * @param current (optional) 当前页
     * @param keyWord (optional) keyWord
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageAndonReason(current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfAndonTypeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageAndonReason(_response);
        });
    }

    protected processGetPageAndonReason(response: AxiosResponse): Promise<IPageOfAndonTypeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfAndonTypeVO.fromJS(resultData200) : new IPageOfAndonTypeVO();
            return result200;
        }
        return Promise.resolve<IPageOfAndonTypeVO>(<any>null);
    }

    /**
     * 获取设备下不是待接收和已接收状态的呼叫类型
     * @param workStationId (optional) workStationId
     * @return OK
     */
    getAndonTypeWithoutUse(workStationId: string | null | undefined): Promise<AndonTypeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type/without-use?";
        if (workStationId !== undefined)
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAndonTypeWithoutUse(_response);
        });
    }

    protected processGetAndonTypeWithoutUse(response: AxiosResponse): Promise<AndonTypeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AndonTypeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AndonTypeVO[]>(<any>null);
    }
}

export class AndonTypeEmployeeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 根据安灯类型获取处理人员列表
     * @param andonTypeId andonTypeId
     * @return OK
     */
    getAndonType(andonTypeId: string): Promise<AndonTypeEmployeeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/andon-type-employee?";
        if (andonTypeId === undefined || andonTypeId === null)
            throw new Error("The parameter 'andonTypeId' must be defined and cannot be null.");
        else
            url_ += "andonTypeId=" + encodeURIComponent("" + andonTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAndonType(_response);
        });
    }

    protected processGetAndonType(response: AxiosResponse): Promise<AndonTypeEmployeeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AndonTypeEmployeeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AndonTypeEmployeeVO[]>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/app-andon')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class AndonCallRecordAddDTO implements IAndonCallRecordAddDTO {
    /** 呼叫原因编号 */
    andonReasonCode!: string;
    /** 呼叫原因Id */
    andonReasonId!: string;
    /** 呼叫原因名称 */
    andonReasonName!: string;
    /** 安灯类型编号 */
    andonTypeCode!: string;
    /** 安灯类型Id */
    andonTypeId!: string;
    /** 安灯类型名称 */
    andonTypeName!: string;
    /** 呼叫时间 */
    callTime!: Date;
    /** 描述 */
    description!: string | undefined;
    /** 呼叫人员Id */
    employeeId!: string;
    /** 呼叫人员 */
    employeeName!: string;
    /** 接收人员Id */
    receiveEmployeeId!: string | undefined;
    /** 接收人员 */
    receiveEmployeeName!: string | undefined;
    /** 工位编号 */
    workStationCode!: string;
    /** 工位Id */
    workStationId!: string;
    /** 工位名称 */
    workStationName!: string;

    constructor(data?: IAndonCallRecordAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.andonReasonCode = data["andonReasonCode"];
            this.andonReasonId = data["andonReasonId"];
            this.andonReasonName = data["andonReasonName"];
            this.andonTypeCode = data["andonTypeCode"];
            this.andonTypeId = data["andonTypeId"];
            this.andonTypeName = data["andonTypeName"];
            this.callTime = data["callTime"] ? new Date(data["callTime"].toString()) : <any>undefined;
            this.description = data["description"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
            this.receiveEmployeeId = data["receiveEmployeeId"];
            this.receiveEmployeeName = data["receiveEmployeeName"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): AndonCallRecordAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonCallRecordAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["andonReasonCode"] = this.andonReasonCode;
        data["andonReasonId"] = this.andonReasonId;
        data["andonReasonName"] = this.andonReasonName;
        data["andonTypeCode"] = this.andonTypeCode;
        data["andonTypeId"] = this.andonTypeId;
        data["andonTypeName"] = this.andonTypeName;
        data["callTime"] = this.callTime ? this.callTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["receiveEmployeeId"] = this.receiveEmployeeId;
        data["receiveEmployeeName"] = this.receiveEmployeeName;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IAndonCallRecordAddDTO {
    /** 呼叫原因编号 */
    andonReasonCode: string;
    /** 呼叫原因Id */
    andonReasonId: string;
    /** 呼叫原因名称 */
    andonReasonName: string;
    /** 安灯类型编号 */
    andonTypeCode: string;
    /** 安灯类型Id */
    andonTypeId: string;
    /** 安灯类型名称 */
    andonTypeName: string;
    /** 呼叫时间 */
    callTime: Date;
    /** 描述 */
    description: string | undefined;
    /** 呼叫人员Id */
    employeeId: string;
    /** 呼叫人员 */
    employeeName: string;
    /** 接收人员Id */
    receiveEmployeeId: string | undefined;
    /** 接收人员 */
    receiveEmployeeName: string | undefined;
    /** 工位编号 */
    workStationCode: string;
    /** 工位Id */
    workStationId: string;
    /** 工位名称 */
    workStationName: string;
}

export class AndonCallRecordBO implements IAndonCallRecordBO {
    /** 呼叫原因编号 */
    andonReasonCode!: string | undefined;
    /** 呼叫原因Id */
    andonReasonId!: string | undefined;
    /** 呼叫原因名称 */
    andonReasonName!: string | undefined;
    /** 安灯类型编号 */
    andonTypeCode!: string | undefined;
    /** 安灯类型Id */
    andonTypeId!: string | undefined;
    /** 安灯类型名称 */
    andonTypeName!: string | undefined;
    /** 呼叫总时长 */
    callSpendTime!: string | undefined;
    /** 呼叫状态：0.待接收，1.已接收，2.已完成 */
    callStatus!: number | undefined;
    /** 呼叫时间 */
    callTime!: Date | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 呼叫人员Id */
    employeeId!: string | undefined;
    /** 呼叫人员 */
    employeeName!: string | undefined;
    /** 完成人员Id */
    finishEmployeeId!: string | undefined;
    /** 完成人员 */
    finishEmployeeName!: string | undefined;
    /** 完成时间 */
    finishTime!: Date | undefined;
    /** 处理时长 */
    fixSpendTime!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 接收人员Id */
    receiveEmployeeId!: string | undefined;
    /** 接收人员 */
    receiveEmployeeName!: string | undefined;
    /** 备注信息 */
    remark!: string | undefined;
    /** 响应人员Id */
    responseEmployeeId!: string | undefined;
    /** 响应人员 */
    responseEmployeeName!: string | undefined;
    /** 响应时长 */
    responseSpendTime!: string | undefined;
    /** 响应时间 */
    responseTime!: Date | undefined;
    /** 工位编号 */
    workStationCode!: string | undefined;
    /** 工位Id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IAndonCallRecordBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.andonReasonCode = data["andonReasonCode"];
            this.andonReasonId = data["andonReasonId"];
            this.andonReasonName = data["andonReasonName"];
            this.andonTypeCode = data["andonTypeCode"];
            this.andonTypeId = data["andonTypeId"];
            this.andonTypeName = data["andonTypeName"];
            this.callSpendTime = data["callSpendTime"];
            this.callStatus = data["callStatus"];
            this.callTime = data["callTime"] ? new Date(data["callTime"].toString()) : <any>undefined;
            this.description = data["description"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
            this.finishEmployeeId = data["finishEmployeeId"];
            this.finishEmployeeName = data["finishEmployeeName"];
            this.finishTime = data["finishTime"] ? new Date(data["finishTime"].toString()) : <any>undefined;
            this.fixSpendTime = data["fixSpendTime"];
            this.id = data["id"];
            this.receiveEmployeeId = data["receiveEmployeeId"];
            this.receiveEmployeeName = data["receiveEmployeeName"];
            this.remark = data["remark"];
            this.responseEmployeeId = data["responseEmployeeId"];
            this.responseEmployeeName = data["responseEmployeeName"];
            this.responseSpendTime = data["responseSpendTime"];
            this.responseTime = data["responseTime"] ? new Date(data["responseTime"].toString()) : <any>undefined;
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): AndonCallRecordBO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonCallRecordBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["andonReasonCode"] = this.andonReasonCode;
        data["andonReasonId"] = this.andonReasonId;
        data["andonReasonName"] = this.andonReasonName;
        data["andonTypeCode"] = this.andonTypeCode;
        data["andonTypeId"] = this.andonTypeId;
        data["andonTypeName"] = this.andonTypeName;
        data["callSpendTime"] = this.callSpendTime;
        data["callStatus"] = this.callStatus;
        data["callTime"] = this.callTime ? this.callTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["finishEmployeeId"] = this.finishEmployeeId;
        data["finishEmployeeName"] = this.finishEmployeeName;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["fixSpendTime"] = this.fixSpendTime;
        data["id"] = this.id;
        data["receiveEmployeeId"] = this.receiveEmployeeId;
        data["receiveEmployeeName"] = this.receiveEmployeeName;
        data["remark"] = this.remark;
        data["responseEmployeeId"] = this.responseEmployeeId;
        data["responseEmployeeName"] = this.responseEmployeeName;
        data["responseSpendTime"] = this.responseSpendTime;
        data["responseTime"] = this.responseTime ? this.responseTime.toISOString() : <any>undefined;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IAndonCallRecordBO {
    /** 呼叫原因编号 */
    andonReasonCode: string | undefined;
    /** 呼叫原因Id */
    andonReasonId: string | undefined;
    /** 呼叫原因名称 */
    andonReasonName: string | undefined;
    /** 安灯类型编号 */
    andonTypeCode: string | undefined;
    /** 安灯类型Id */
    andonTypeId: string | undefined;
    /** 安灯类型名称 */
    andonTypeName: string | undefined;
    /** 呼叫总时长 */
    callSpendTime: string | undefined;
    /** 呼叫状态：0.待接收，1.已接收，2.已完成 */
    callStatus: number | undefined;
    /** 呼叫时间 */
    callTime: Date | undefined;
    /** 描述 */
    description: string | undefined;
    /** 呼叫人员Id */
    employeeId: string | undefined;
    /** 呼叫人员 */
    employeeName: string | undefined;
    /** 完成人员Id */
    finishEmployeeId: string | undefined;
    /** 完成人员 */
    finishEmployeeName: string | undefined;
    /** 完成时间 */
    finishTime: Date | undefined;
    /** 处理时长 */
    fixSpendTime: string | undefined;
    /** id */
    id: string | undefined;
    /** 接收人员Id */
    receiveEmployeeId: string | undefined;
    /** 接收人员 */
    receiveEmployeeName: string | undefined;
    /** 备注信息 */
    remark: string | undefined;
    /** 响应人员Id */
    responseEmployeeId: string | undefined;
    /** 响应人员 */
    responseEmployeeName: string | undefined;
    /** 响应时长 */
    responseSpendTime: string | undefined;
    /** 响应时间 */
    responseTime: Date | undefined;
    /** 工位编号 */
    workStationCode: string | undefined;
    /** 工位Id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class AndonCallRecordConfirmSearchDTO implements IAndonCallRecordConfirmSearchDTO {
    /** 安灯呼叫类型Id */
    andonTypeId!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 工位Id列表 */
    workStationIds!: string[] | undefined;

    constructor(data?: IAndonCallRecordConfirmSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.andonTypeId = data["andonTypeId"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            if (data["workStationIds"] && data["workStationIds"].constructor === Array) {
                this.workStationIds = [] as any;
                for (let item of data["workStationIds"])
                    this.workStationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AndonCallRecordConfirmSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonCallRecordConfirmSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["andonTypeId"] = this.andonTypeId;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        if (this.workStationIds && this.workStationIds.constructor === Array) {
            data["workStationIds"] = [];
            for (let item of this.workStationIds)
                data["workStationIds"].push(item);
        }
        return data; 
    }
}

export interface IAndonCallRecordConfirmSearchDTO {
    /** 安灯呼叫类型Id */
    andonTypeId: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 工位Id列表 */
    workStationIds: string[] | undefined;
}

export class AndonCallRecordSearchDTO implements IAndonCallRecordSearchDTO {
    /** 安灯呼叫原因Id */
    andonReasonId!: string | undefined;
    /** 安灯呼叫类型Id */
    andonTypeId!: string | undefined;
    /** 呼叫状态，0.待接收，1.已接收，2.已完成 */
    callStatus!: number[] | undefined;
    /** 发起人code */
    employeeCode!: string | undefined;
    /** 工位ID */
    workStationId!: string | undefined;

    constructor(data?: IAndonCallRecordSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.andonReasonId = data["andonReasonId"];
            this.andonTypeId = data["andonTypeId"];
            if (data["callStatus"] && data["callStatus"].constructor === Array) {
                this.callStatus = [] as any;
                for (let item of data["callStatus"])
                    this.callStatus!.push(item);
            }
            this.employeeCode = data["employeeCode"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): AndonCallRecordSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonCallRecordSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["andonReasonId"] = this.andonReasonId;
        data["andonTypeId"] = this.andonTypeId;
        if (this.callStatus && this.callStatus.constructor === Array) {
            data["callStatus"] = [];
            for (let item of this.callStatus)
                data["callStatus"].push(item);
        }
        data["employeeCode"] = this.employeeCode;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IAndonCallRecordSearchDTO {
    /** 安灯呼叫原因Id */
    andonReasonId: string | undefined;
    /** 安灯呼叫类型Id */
    andonTypeId: string | undefined;
    /** 呼叫状态，0.待接收，1.已接收，2.已完成 */
    callStatus: number[] | undefined;
    /** 发起人code */
    employeeCode: string | undefined;
    /** 工位ID */
    workStationId: string | undefined;
}

export class AndonCallRecordUpdateCallStatusDTO implements IAndonCallRecordUpdateCallStatusDTO {
    /** 安灯呼叫信息状态 0：待接收，1.已接收，2.已完成 */
    callStatus!: number | undefined;
    /** ID */
    id!: string | undefined;

    constructor(data?: IAndonCallRecordUpdateCallStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.callStatus = data["callStatus"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AndonCallRecordUpdateCallStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonCallRecordUpdateCallStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callStatus"] = this.callStatus;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAndonCallRecordUpdateCallStatusDTO {
    /** 安灯呼叫信息状态 0：待接收，1.已接收，2.已完成 */
    callStatus: number | undefined;
    /** ID */
    id: string | undefined;
}

export class AndonCallRecordUpdateDTO implements IAndonCallRecordUpdateDTO {
    /** ID */
    id!: string | undefined;
    /** 备注信息 */
    remark!: string | undefined;

    constructor(data?: IAndonCallRecordUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): AndonCallRecordUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonCallRecordUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IAndonCallRecordUpdateDTO {
    /** ID */
    id: string | undefined;
    /** 备注信息 */
    remark: string | undefined;
}

export class AndonCallRecordUpdateStatusDTO implements IAndonCallRecordUpdateStatusDTO {
    /** 安灯呼叫信息状态 0：待接收，1.已接收，2.已完成 */
    callStatus!: number | undefined;
    /** 登录员工信息 */
    employeeId!: string | undefined;
    /** 安灯呼叫记录ID列表 */
    ids!: string[] | undefined;

    constructor(data?: IAndonCallRecordUpdateStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.callStatus = data["callStatus"];
            this.employeeId = data["employeeId"];
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [] as any;
                for (let item of data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): AndonCallRecordUpdateStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonCallRecordUpdateStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callStatus"] = this.callStatus;
        data["employeeId"] = this.employeeId;
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IAndonCallRecordUpdateStatusDTO {
    /** 安灯呼叫信息状态 0：待接收，1.已接收，2.已完成 */
    callStatus: number | undefined;
    /** 登录员工信息 */
    employeeId: string | undefined;
    /** 安灯呼叫记录ID列表 */
    ids: string[] | undefined;
}

export class AndonFrequencyStatisticsReportVO implements IAndonFrequencyStatisticsReportVO {
    /** 安灯呼叫原因编号 */
    andonReasonCode!: string | undefined;
    /** 安灯呼叫原因id */
    andonReasonId!: string | undefined;
    /** 安灯呼叫原因名称 */
    andonReasonName!: string | undefined;
    /** 安灯呼叫类型编号 */
    andonTypeCode!: string | undefined;
    /** 安灯呼叫类型id */
    andonTypeId!: string | undefined;
    /** 安灯呼叫类型名称 */
    andonTypeName!: string | undefined;
    /** 呼叫时间 */
    callTime!: Date | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 呼叫人员Id */
    employeeId!: string | undefined;
    /** 呼叫人员 */
    employeeName!: string | undefined;
    /** 结束时间 */
    finishTime!: Date | undefined;
    /** 处理时长(秒) */
    fixSpendTime!: string | undefined;
    /** 处理时长(字符串) */
    fixSpendTimeString!: string | undefined;
    /** 呼叫次数 */
    number!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 响应时长(秒) */
    responseSpendTime!: string | undefined;
    /** 响应时长(字符串) */
    responseSpendTimeString!: string | undefined;
    /** 设备id */
    workStationId!: string | undefined;
    /** 设备名称 */
    workStationName!: string | undefined;

    constructor(data?: IAndonFrequencyStatisticsReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.andonReasonCode = data["andonReasonCode"];
            this.andonReasonId = data["andonReasonId"];
            this.andonReasonName = data["andonReasonName"];
            this.andonTypeCode = data["andonTypeCode"];
            this.andonTypeId = data["andonTypeId"];
            this.andonTypeName = data["andonTypeName"];
            this.callTime = data["callTime"] ? new Date(data["callTime"].toString()) : <any>undefined;
            this.description = data["description"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
            this.finishTime = data["finishTime"] ? new Date(data["finishTime"].toString()) : <any>undefined;
            this.fixSpendTime = data["fixSpendTime"];
            this.fixSpendTimeString = data["fixSpendTimeString"];
            this.number = data["number"];
            this.remark = data["remark"];
            this.responseSpendTime = data["responseSpendTime"];
            this.responseSpendTimeString = data["responseSpendTimeString"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): AndonFrequencyStatisticsReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonFrequencyStatisticsReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["andonReasonCode"] = this.andonReasonCode;
        data["andonReasonId"] = this.andonReasonId;
        data["andonReasonName"] = this.andonReasonName;
        data["andonTypeCode"] = this.andonTypeCode;
        data["andonTypeId"] = this.andonTypeId;
        data["andonTypeName"] = this.andonTypeName;
        data["callTime"] = this.callTime ? this.callTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["fixSpendTime"] = this.fixSpendTime;
        data["fixSpendTimeString"] = this.fixSpendTimeString;
        data["number"] = this.number;
        data["remark"] = this.remark;
        data["responseSpendTime"] = this.responseSpendTime;
        data["responseSpendTimeString"] = this.responseSpendTimeString;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IAndonFrequencyStatisticsReportVO {
    /** 安灯呼叫原因编号 */
    andonReasonCode: string | undefined;
    /** 安灯呼叫原因id */
    andonReasonId: string | undefined;
    /** 安灯呼叫原因名称 */
    andonReasonName: string | undefined;
    /** 安灯呼叫类型编号 */
    andonTypeCode: string | undefined;
    /** 安灯呼叫类型id */
    andonTypeId: string | undefined;
    /** 安灯呼叫类型名称 */
    andonTypeName: string | undefined;
    /** 呼叫时间 */
    callTime: Date | undefined;
    /** 描述 */
    description: string | undefined;
    /** 呼叫人员Id */
    employeeId: string | undefined;
    /** 呼叫人员 */
    employeeName: string | undefined;
    /** 结束时间 */
    finishTime: Date | undefined;
    /** 处理时长(秒) */
    fixSpendTime: string | undefined;
    /** 处理时长(字符串) */
    fixSpendTimeString: string | undefined;
    /** 呼叫次数 */
    number: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 响应时长(秒) */
    responseSpendTime: string | undefined;
    /** 响应时长(字符串) */
    responseSpendTimeString: string | undefined;
    /** 设备id */
    workStationId: string | undefined;
    /** 设备名称 */
    workStationName: string | undefined;
}

export class AndonReasonCodeNameVO implements IAndonReasonCodeNameVO {
    /** 安灯原因编号 */
    codeAndName!: string | undefined;
    /** 安灯原因id */
    id!: string | undefined;

    constructor(data?: IAndonReasonCodeNameVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.codeAndName = data["codeAndName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AndonReasonCodeNameVO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonReasonCodeNameVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeAndName"] = this.codeAndName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAndonReasonCodeNameVO {
    /** 安灯原因编号 */
    codeAndName: string | undefined;
    /** 安灯原因id */
    id: string | undefined;
}

export class AndonReasonDTO implements IAndonReasonDTO {
    /** 安灯原因编号 */
    code!: string;
    /** 安灯原因id */
    id!: string | undefined;
    /** 安灯原因 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;
    /** 安灯类型ID */
    typeId!: string;

    constructor(data?: IAndonReasonDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): AndonReasonDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonReasonDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IAndonReasonDTO {
    /** 安灯原因编号 */
    code: string;
    /** 安灯原因id */
    id: string | undefined;
    /** 安灯原因 */
    name: string;
    /** 备注 */
    remark: string | undefined;
    /** 安灯类型ID */
    typeId: string;
}

export class AndonReasonVO implements IAndonReasonVO {
    /** 安灯原因编号 */
    code!: string | undefined;
    /** 安灯原因id */
    id!: string | undefined;
    /** 安灯原因 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IAndonReasonVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): AndonReasonVO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonReasonVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IAndonReasonVO {
    /** 安灯原因编号 */
    code: string | undefined;
    /** 安灯原因id */
    id: string | undefined;
    /** 安灯原因 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class AndonStatisticsFrequencyDTO implements IAndonStatisticsFrequencyDTO {
    /** 日 */
    date!: Date;
    /** 结束时间 */
    endDate!: Date;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 开始时间 */
    startDate!: Date;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: AndonStatisticsFrequencyDTOStatisticalMethod;
    /** 设备id集合 */
    workStationIds!: string[];

    constructor(data?: IAndonStatisticsFrequencyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.workStationIds = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.shiftIndex = data["shiftIndex"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            if (data["workStationIds"] && data["workStationIds"].constructor === Array) {
                this.workStationIds = [] as any;
                for (let item of data["workStationIds"])
                    this.workStationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AndonStatisticsFrequencyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonStatisticsFrequencyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["shiftIndex"] = this.shiftIndex;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        if (this.workStationIds && this.workStationIds.constructor === Array) {
            data["workStationIds"] = [];
            for (let item of this.workStationIds)
                data["workStationIds"].push(item);
        }
        return data; 
    }
}

export interface IAndonStatisticsFrequencyDTO {
    /** 日 */
    date: Date;
    /** 结束时间 */
    endDate: Date;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 开始时间 */
    startDate: Date;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: AndonStatisticsFrequencyDTOStatisticalMethod;
    /** 设备id集合 */
    workStationIds: string[];
}

export class AndonStatisticsFrequencyExportDTO implements IAndonStatisticsFrequencyExportDTO {
    /** 日 */
    dateList!: string[];
    /** 结束时间 */
    endDate!: Date;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate!: Date;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: AndonStatisticsFrequencyExportDTOStatisticalMethod;
    /** 设备id集合 */
    workStationIds!: string[];

    constructor(data?: IAndonStatisticsFrequencyExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dateList = [];
            this.workStationIds = [];
        }
    }

    init(data?: any) {
        if (data) {
            if (data["dateList"] && data["dateList"].constructor === Array) {
                this.dateList = [] as any;
                for (let item of data["dateList"])
                    this.dateList!.push(item);
            }
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            if (data["workStationIds"] && data["workStationIds"].constructor === Array) {
                this.workStationIds = [] as any;
                for (let item of data["workStationIds"])
                    this.workStationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AndonStatisticsFrequencyExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonStatisticsFrequencyExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dateList && this.dateList.constructor === Array) {
            data["dateList"] = [];
            for (let item of this.dateList)
                data["dateList"].push(item);
        }
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        if (this.workStationIds && this.workStationIds.constructor === Array) {
            data["workStationIds"] = [];
            for (let item of this.workStationIds)
                data["workStationIds"].push(item);
        }
        return data; 
    }
}

export interface IAndonStatisticsFrequencyExportDTO {
    /** 日 */
    dateList: string[];
    /** 结束时间 */
    endDate: Date;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate: Date;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: AndonStatisticsFrequencyExportDTOStatisticalMethod;
    /** 设备id集合 */
    workStationIds: string[];
}

export class AndonTypeCodeNameVO implements IAndonTypeCodeNameVO {
    /** 安灯类型编号 */
    code!: string | undefined;
    /** 安灯类型编号 */
    codeAndName!: string | undefined;
    /** 安灯类型id */
    id!: string | undefined;
    /** 安灯类型名称 */
    name!: string | undefined;

    constructor(data?: IAndonTypeCodeNameVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeAndName = data["codeAndName"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): AndonTypeCodeNameVO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonTypeCodeNameVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeAndName"] = this.codeAndName;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IAndonTypeCodeNameVO {
    /** 安灯类型编号 */
    code: string | undefined;
    /** 安灯类型编号 */
    codeAndName: string | undefined;
    /** 安灯类型id */
    id: string | undefined;
    /** 安灯类型名称 */
    name: string | undefined;
}

export class AndonTypeDTO implements IAndonTypeDTO {
    /** 安灯类型编号 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 类型状态颜色 */
    color!: string | undefined;
    /** 接收人员IDS */
    employeeIds!: string | undefined;
    /** 接收人员名称列表 */
    employeeNames!: string | undefined;
    /** 安灯类型id */
    id!: string | undefined;
    /** 安灯类型名称 */
    name!: string;
    /** 新接收人员列表 */
    newAndonTypeEmployeeDTOS!: AndonTypeEmployeeDTO[] | undefined;
    /** 旧接收人员列表 */
    oldAndonTypeEmployeeDTOS!: AndonTypeEmployeeDTO[] | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IAndonTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.color = data["color"];
            this.employeeIds = data["employeeIds"];
            this.employeeNames = data["employeeNames"];
            this.id = data["id"];
            this.name = data["name"];
            if (data["newAndonTypeEmployeeDTOS"] && data["newAndonTypeEmployeeDTOS"].constructor === Array) {
                this.newAndonTypeEmployeeDTOS = [] as any;
                for (let item of data["newAndonTypeEmployeeDTOS"])
                    this.newAndonTypeEmployeeDTOS!.push(AndonTypeEmployeeDTO.fromJS(item));
            }
            if (data["oldAndonTypeEmployeeDTOS"] && data["oldAndonTypeEmployeeDTOS"].constructor === Array) {
                this.oldAndonTypeEmployeeDTOS = [] as any;
                for (let item of data["oldAndonTypeEmployeeDTOS"])
                    this.oldAndonTypeEmployeeDTOS!.push(AndonTypeEmployeeDTO.fromJS(item));
            }
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): AndonTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["color"] = this.color;
        data["employeeIds"] = this.employeeIds;
        data["employeeNames"] = this.employeeNames;
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.newAndonTypeEmployeeDTOS && this.newAndonTypeEmployeeDTOS.constructor === Array) {
            data["newAndonTypeEmployeeDTOS"] = [];
            for (let item of this.newAndonTypeEmployeeDTOS)
                data["newAndonTypeEmployeeDTOS"].push(item.toJSON());
        }
        if (this.oldAndonTypeEmployeeDTOS && this.oldAndonTypeEmployeeDTOS.constructor === Array) {
            data["oldAndonTypeEmployeeDTOS"] = [];
            for (let item of this.oldAndonTypeEmployeeDTOS)
                data["oldAndonTypeEmployeeDTOS"].push(item.toJSON());
        }
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IAndonTypeDTO {
    /** 安灯类型编号 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 类型状态颜色 */
    color: string | undefined;
    /** 接收人员IDS */
    employeeIds: string | undefined;
    /** 接收人员名称列表 */
    employeeNames: string | undefined;
    /** 安灯类型id */
    id: string | undefined;
    /** 安灯类型名称 */
    name: string;
    /** 新接收人员列表 */
    newAndonTypeEmployeeDTOS: AndonTypeEmployeeDTO[] | undefined;
    /** 旧接收人员列表 */
    oldAndonTypeEmployeeDTOS: AndonTypeEmployeeDTO[] | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class AndonTypeEmployeeDTO implements IAndonTypeEmployeeDTO {
    /** 员工编号 */
    employeeCode!: string | undefined;
    /** 员工id */
    employeeId!: string | undefined;
    /** 员工名称 */
    employeeName!: string | undefined;

    constructor(data?: IAndonTypeEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.employeeCode = data["employeeCode"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
        }
    }

    static fromJS(data: any): AndonTypeEmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonTypeEmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        return data; 
    }
}

export interface IAndonTypeEmployeeDTO {
    /** 员工编号 */
    employeeCode: string | undefined;
    /** 员工id */
    employeeId: string | undefined;
    /** 员工名称 */
    employeeName: string | undefined;
}

export class AndonTypeEmployeeVO implements IAndonTypeEmployeeVO {
    /** 呼叫类型ID */
    andonTypeId!: string | undefined;
    /** 员工编号 */
    employeeCode!: string | undefined;
    /** 员工id */
    employeeId!: string | undefined;
    /** 员工名称 */
    employeeName!: string | undefined;

    constructor(data?: IAndonTypeEmployeeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.andonTypeId = data["andonTypeId"];
            this.employeeCode = data["employeeCode"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
        }
    }

    static fromJS(data: any): AndonTypeEmployeeVO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonTypeEmployeeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["andonTypeId"] = this.andonTypeId;
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        return data; 
    }
}

export interface IAndonTypeEmployeeVO {
    /** 呼叫类型ID */
    andonTypeId: string | undefined;
    /** 员工编号 */
    employeeCode: string | undefined;
    /** 员工id */
    employeeId: string | undefined;
    /** 员工名称 */
    employeeName: string | undefined;
}

export class AndonTypeVO implements IAndonTypeVO {
    /** 安灯类型编号 */
    code!: string | undefined;
    /** 类型状态颜色 */
    color!: string | undefined;
    /** 处理人员Ids */
    employeeIds!: string | undefined;
    /** 处理人员名称 */
    employeeNames!: string | undefined;
    /** 安灯类型id */
    id!: string | undefined;
    /** 安灯类型 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IAndonTypeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.color = data["color"];
            this.employeeIds = data["employeeIds"];
            this.employeeNames = data["employeeNames"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): AndonTypeVO {
        data = typeof data === 'object' ? data : {};
        let result = new AndonTypeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["color"] = this.color;
        data["employeeIds"] = this.employeeIds;
        data["employeeNames"] = this.employeeNames;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IAndonTypeVO {
    /** 安灯类型编号 */
    code: string | undefined;
    /** 类型状态颜色 */
    color: string | undefined;
    /** 处理人员Ids */
    employeeIds: string | undefined;
    /** 处理人员名称 */
    employeeNames: string | undefined;
    /** 安灯类型id */
    id: string | undefined;
    /** 安灯类型 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class IPageOfAndonCallRecordBO implements IIPageOfAndonCallRecordBO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: AndonCallRecordBO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAndonCallRecordBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AndonCallRecordBO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAndonCallRecordBO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAndonCallRecordBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAndonCallRecordBO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: AndonCallRecordBO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfAndonReasonVO implements IIPageOfAndonReasonVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: AndonReasonVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAndonReasonVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AndonReasonVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAndonReasonVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAndonReasonVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAndonReasonVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: AndonReasonVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfAndonTypeVO implements IIPageOfAndonTypeVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: AndonTypeVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAndonTypeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AndonTypeVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAndonTypeVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAndonTypeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAndonTypeVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: AndonTypeVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfPageAndonCallRecordBO implements IIPageOfPageAndonCallRecordBO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: PageAndonCallRecordBO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfPageAndonCallRecordBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(PageAndonCallRecordBO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfPageAndonCallRecordBO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfPageAndonCallRecordBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfPageAndonCallRecordBO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: PageAndonCallRecordBO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class KeyNameDTO implements IKeyNameDTO {
    /** key */
    key!: string | undefined;
    /** 名称 */
    name!: string | undefined;

    constructor(data?: IKeyNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): KeyNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KeyNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        return data; 
    }
}

export interface IKeyNameDTO {
    /** key */
    key: string | undefined;
    /** 名称 */
    name: string | undefined;
}

/** 安灯呼叫记录表 */
export class PageAndonCallRecordBO implements IPageAndonCallRecordBO {
    /** 呼叫原因编号 */
    andonReasonCode!: string | undefined;
    /** 呼叫原因Id */
    andonReasonId!: string | undefined;
    /** 呼叫原因名称 */
    andonReasonName!: string | undefined;
    /** 安灯类型编号 */
    andonTypeCode!: string | undefined;
    /** 处理人员 */
    andonTypeEmployeeVOS!: AndonTypeEmployeeVO[] | undefined;
    /** 安灯类型Id */
    andonTypeId!: string | undefined;
    /** 安灯类型名称 */
    andonTypeName!: string | undefined;
    /** 呼叫状态：0.待接收，1.已接收，2.已完成 */
    callStatus!: number | undefined;
    /** 呼叫时间 */
    callTime!: Date | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 呼叫人员Id */
    employeeId!: string | undefined;
    /** 呼叫人员 */
    employeeName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 接收人员ID */
    receiveEmployeeId!: string | undefined;
    /** 接收人员 */
    receiveEmployeeName!: string | undefined;
    /** 备注信息 */
    remark!: string | undefined;
    /** 工位编号 */
    workStationCode!: string | undefined;
    /** 工位Id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IPageAndonCallRecordBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.andonReasonCode = data["andonReasonCode"];
            this.andonReasonId = data["andonReasonId"];
            this.andonReasonName = data["andonReasonName"];
            this.andonTypeCode = data["andonTypeCode"];
            if (data["andonTypeEmployeeVOS"] && data["andonTypeEmployeeVOS"].constructor === Array) {
                this.andonTypeEmployeeVOS = [] as any;
                for (let item of data["andonTypeEmployeeVOS"])
                    this.andonTypeEmployeeVOS!.push(AndonTypeEmployeeVO.fromJS(item));
            }
            this.andonTypeId = data["andonTypeId"];
            this.andonTypeName = data["andonTypeName"];
            this.callStatus = data["callStatus"];
            this.callTime = data["callTime"] ? new Date(data["callTime"].toString()) : <any>undefined;
            this.description = data["description"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
            this.id = data["id"];
            this.receiveEmployeeId = data["receiveEmployeeId"];
            this.receiveEmployeeName = data["receiveEmployeeName"];
            this.remark = data["remark"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): PageAndonCallRecordBO {
        data = typeof data === 'object' ? data : {};
        let result = new PageAndonCallRecordBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["andonReasonCode"] = this.andonReasonCode;
        data["andonReasonId"] = this.andonReasonId;
        data["andonReasonName"] = this.andonReasonName;
        data["andonTypeCode"] = this.andonTypeCode;
        if (this.andonTypeEmployeeVOS && this.andonTypeEmployeeVOS.constructor === Array) {
            data["andonTypeEmployeeVOS"] = [];
            for (let item of this.andonTypeEmployeeVOS)
                data["andonTypeEmployeeVOS"].push(item.toJSON());
        }
        data["andonTypeId"] = this.andonTypeId;
        data["andonTypeName"] = this.andonTypeName;
        data["callStatus"] = this.callStatus;
        data["callTime"] = this.callTime ? this.callTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["id"] = this.id;
        data["receiveEmployeeId"] = this.receiveEmployeeId;
        data["receiveEmployeeName"] = this.receiveEmployeeName;
        data["remark"] = this.remark;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

/** 安灯呼叫记录表 */
export interface IPageAndonCallRecordBO {
    /** 呼叫原因编号 */
    andonReasonCode: string | undefined;
    /** 呼叫原因Id */
    andonReasonId: string | undefined;
    /** 呼叫原因名称 */
    andonReasonName: string | undefined;
    /** 安灯类型编号 */
    andonTypeCode: string | undefined;
    /** 处理人员 */
    andonTypeEmployeeVOS: AndonTypeEmployeeVO[] | undefined;
    /** 安灯类型Id */
    andonTypeId: string | undefined;
    /** 安灯类型名称 */
    andonTypeName: string | undefined;
    /** 呼叫状态：0.待接收，1.已接收，2.已完成 */
    callStatus: number | undefined;
    /** 呼叫时间 */
    callTime: Date | undefined;
    /** 描述 */
    description: string | undefined;
    /** 呼叫人员Id */
    employeeId: string | undefined;
    /** 呼叫人员 */
    employeeName: string | undefined;
    /** id */
    id: string | undefined;
    /** 接收人员ID */
    receiveEmployeeId: string | undefined;
    /** 接收人员 */
    receiveEmployeeName: string | undefined;
    /** 备注信息 */
    remark: string | undefined;
    /** 工位编号 */
    workStationCode: string | undefined;
    /** 工位Id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

export enum AndonStatisticsFrequencyDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
}

export enum AndonStatisticsFrequencyExportDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
}

export interface FileParameter {
    data: any;
    fileName: string;
}